import { __assign } from "tslib";
import { connectMediaStore } from './withOwnReduxStore';
import { initMediaPopup } from '../actions';
import { normalize } from '../../redux/normalizr';
import { galleryFolderSchema, collectionFolderSchema, } from '../../redux/normalizr/schemas/folder';
import { MediaSourceType } from '../types';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
export default connectMediaStore(null, function (dispatch) { return ({
    initMediaPopup: function (payload) {
        var mediaSource = payload.mediaSource, gallectionFolder = payload.gallectionFolder, tier = payload.tier;
        var entities;
        if (gallectionFolder) {
            var gallectionSchema = mediaSource === MediaSourceType.COLLECTION
                ? collectionFolderSchema
                : galleryFolderSchema;
            var normalized = normalize(gallectionFolder, gallectionSchema);
            entities = normalized.entities;
        }
        else if (tier) {
            var normalized = normalize(tier, deviationSchema);
            entities = normalized.entities;
        }
        dispatch(initMediaPopup(__assign(__assign({}, payload), { entities: entities })));
    },
}); });
//# sourceMappingURL=withMediaPopupInit.js.map